import { RestoreFromTrash as RestoreFromTrashIcon } from '@mui/icons-material';
import { MouseEvent } from 'react';
import { Button, useRecordContext, useRefresh } from 'react-admin';
import { Command } from '../../types/commands';
import { useRestoreCommand } from './useRestoreCommand';

interface CommandRestoreButtonProps {
  /** Datagrid rows are clickable, so the click must not also open the record. */
  stopPropagation?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
}

/**
 * Restore action for a soft-deleted command. Renders nothing for active
 * commands, so it can be dropped into a list row or a show layout as is.
 */
export const CommandRestoreButton = ({
  stopPropagation = false,
  variant = 'outlined',
  size = 'small',
}: CommandRestoreButtonProps) => {
  const record = useRecordContext<Command>();
  const refresh = useRefresh();
  const { restore, isRestoring } = useRestoreCommand();

  if (!record?.deleted_at) return null;

  const handleClick = async (event: MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }

    if (await restore(record.id, record.name)) {
      refresh();
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={isRestoring}
      variant={variant}
      size={size}
      startIcon={<RestoreFromTrashIcon />}
      label="resources.commands.restore.action"
    />
  );
};
